<template>
  <div class="l-page l-page--analysis">
    <!-- サイドバーエリア -->
    <page-sidebar />
    <!-- /サイドバーエリア -->
    <main class="l-main">
      <div class="l-main-head">
        <!-- パンくずリスト -->
        <breadcrumb :breadcrumb-data="breadcrumbData" :additional-classes="['p-breadcrumb--analysis']" />
        <!-- /パンくずリスト -->
        <date-range-picker
          ref="refCalendarModal"
          :initial-start-date="calendarStartDate"
          :initial-end-date="calendarEndDate"
          :on-date-range-changed="onDateRangeChanged"
          cancel-button-label="キャンセル"
          enter-button-label="決定"
        />
      </div>
      <div class="l-main-content">
        <div class="p-analysis-device">
          <h2 class="c-title">
            <div class="c-title__text u-fs34">デバイス別での傾向</div>
            <div class="c-date u-w400">
              <div class="c-date__title"></div>
              <ul class="c-date-list">
                <li class="c-date-list__item c-date-list__item--label">表示期間</li>
                <li class="c-date-list__item c-date-list__item--from">{{ displayStartDate }}</li>
                <li class="c-date-list__item c-date-list__item--to">{{ displayEndDate }}</li>
              </ul>
            </div>
          </h2>
          <analysis-tab
            classes="c-tab--device"
            :current="tab.current"
            :on-select="onTabClick"
          />
          <h3 class="c-title">
            <div class="c-title__text u-fs--l">全ての配信結果に対しての割合</div>
          </h3>
          <div
            class="p-analysis-device__graph"
            :class="[{'is-loading': isLoadingGraph}, {'is-empty': isEmpty}]"
          >
            <div class="c-loader"></div>
            <div class="c-empty">
              <div class="c-empty__text">配信後にデータが反映されます</div>
            </div>
            <div class="c-graph-donuts-wrapper">
              <svg class="c-graph-donuts c-graph-donuts--device">
                <g class="c-graph-donuts__chart" />
                <g class="c-graph-donuts__values" />
                <g class="c-graph-donuts__title" />
                <g class="c-graph-donuts__labels" />
              </svg>
              <div class="c-tooltip c-tooltip--graph-donuts c-tooltip--device">
                <ul class="c-tooltip-list">
                  <li class="c-tooltip-list__item c-tooltip-list__item--desktop is-active">-</li>
                  <li class="c-tooltip-list__item c-tooltip-list__item--mobile is-active">-</li>
                  <li class="c-tooltip-list__item c-tooltip-list__item--tablet is-active">-</li>
                  <li class="c-tooltip-list__item c-tooltip-list__item--other is-active">-</li>
                </ul>
              </div>
            </div>
          </div>
          <h3 class="c-title c-title--download">
            <div class="c-title__text u-fs--l">全ての配信結果での合計数</div>
            <div class="c-text"><a :href="deviceCsvUrl">CSVデータ ダウンロード</a></div>
          </h3>
          <div
            class="p-analysis-device__data"
            :class="[{'is-loading': isLoadingDataTable}, {'is-empty': isEmpty}]"
          >
            <div class="c-loader"></div>
            <div class="c-empty">
              <div class="c-empty__text">配信後にデータが反映されます</div>
            </div>
            <table class="c-table c-table--graph-donuts">
              <thead>
                <tr>
                  <th class="c-table__cell--center is-sortable">
                    <span class="c-table__text">デバイス</span>
                    <span
                      class="c-btn c-btn--sort"
                      :class="[
                        {'c-btn--sort-asc': sort.key == 'deviceId' && sort.type == 'asc'},
                        {'c-btn--sort-desc': sort.key == 'deviceId' && sort.type == 'desc'},
                      ]"
                      @click="(e) => { onSortClick(e, 'deviceId') }"
                    ></span>
                  </th>
                  <th class="c-table__cell--center u-w160 is-sortable">
                    <span class="c-table__text">配信対象数</span>
                    <span
                      class="c-btn c-btn--sort"
                      :class="[
                        {'c-btn--sort-asc': sort.key == 'delivery' && sort.type == 'asc'},
                        {'c-btn--sort-desc': sort.key == 'delivery' && sort.type == 'desc'},
                      ]"
                      @click="(e) => { onSortClick(e, 'delivery') }"
                    ></span>
                  </th>
                  <th class="c-table__cell--center u-w160 is-sortable">
                    <span class="c-table__text">インプレッション</span>
                    <span
                      class="c-btn c-btn--sort"
                      :class="[
                        {'c-btn--sort-asc': sort.key == 'impression' && sort.type == 'asc'},
                        {'c-btn--sort-desc': sort.key == 'impression' && sort.type == 'desc'},
                      ]"
                      @click="(e) => { onSortClick(e, 'impression') }"
                    ></span>
                  </th>
                  <th class="c-table__cell--center u-w160 is-sortable">
                    <span class="c-table__text">クリック数</span>
                    <span
                      class="c-btn c-btn--sort"
                      :class="[
                        {'c-btn--sort-asc': sort.key == 'click' && sort.type == 'asc'},
                        {'c-btn--sort-desc': sort.key == 'click' && sort.type == 'desc'},
                      ]"
                      @click="(e) => { onSortClick(e, 'click') }"
                    ></span>
                  </th>
                  <th class="c-table__cell--center u-w160 is-sortable">
                    <span class="c-table__text">クリック率(%)</span>
                    <span
                      class="c-btn c-btn--sort"
                      :class="[
                        {'c-btn--sort-asc': sort.key == 'ctr' && sort.type == 'asc'},
                        {'c-btn--sort-desc': sort.key == 'ctr' && sort.type == 'desc'},
                      ]"
                      @click="(e) => { onSortClick(e, 'ctr') }"
                    ></span>
                  </th>
                </tr>
              </thead>
              <tbody>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

              </tbody>
            </table>
          </div>
        </div>
      </div>
    </main>
    <!-- モーダル: エラーメッセージ表示 -->
    <error-modal
      :is-active=isError
      :message=errorMessage
      :on-close-click="onCloseErrorModal"
    />
  </div>
</template>

<script>
import axios from "axios";
import dayjs from 'dayjs';
import 'dayjs/locale/ja';
dayjs.locale('ja');

export default {
  props: {
    breadcrumbData: Array,
    displayPeriod: Object,
  },

  data: function () {
    return {
      errorMessage: '',
      graphModule: null,
      isEmpty: false,
      isError: false,
      isLoadingGraph: true,
      isLoadingDataTable: true,
      range: {
        from: this.displayPeriod && this.displayPeriod.from && dayjs(this.displayPeriod.from).isValid()
          ? dayjs(this.displayPeriod.from).toDate()
          : dayjs().add(-30, 'days').toDate(),
        to: this.displayPeriod && this.displayPeriod.to && dayjs(this.displayPeriod.to).isValid()
          ? dayjs(this.displayPeriod.to).toDate()
          : dayjs().toDate(),
      },
      tab: {
        current: 'delivery',
      },
      sort: {
        key: 'delivery',
        type: 'desc'
      }
    };
  },

  computed: {
    calendarStartDate: function() {
      return dayjs(this.range.from).isValid()
        ? dayjs(this.range.from).format('YYYY-MM-DD')
        : dayjs().add(-30, 'days').format('YYYY-MM-DD')
    },
    calendarEndDate: function() {
      return dayjs(this.range.to).isValid()
        ? dayjs(this.range.to).format('YYYY-MM-DD')
        : dayjs().format('YYYY-MM-DD')
    },
    displayStartDate: function() {
      return dayjs(this.range.from).isValid()
        ? dayjs(this.range.from).format('YYYY/MM/DD')
        : '-'
    },
    displayEndDate: function() {
      return dayjs(this.range.to).isValid()
        ? dayjs(this.range.to).format('YYYY/MM/DD')
        : '-'
    },
    deviceCsvUrl: function() {
      let url = '/api/analysis/summary-device/csv?' +
        'from=' + dayjs(this.range.from).format('YYYY-MM-DD') +
        '&to=' + dayjs(this.range.to).format('YYYY-MM-DD');
      return url;
    },

  },

  mounted: function() {
    // グラフモジュールの読み込み
    import('../../funcs/components/graph/graph-donuts-delivery-device').then(module => {
      // モジュールオブジェクトをプロパティに設定
      this.graphModule = module;
      // モジュール読み込み後に初期化処理実行
      this.updateDataset();
    });
  },

  methods: {
    updateDataset: function() {
      // グラフモジュールの読み込みが完了していない場合は処理終了
      if (!this.graphModule) return;

      // ローダー表示設定
      this.isLoadingGraph = true;
      this.isLoadingDataTable = true;

      // 送信パラメーター作成
      const params = {
        from: dayjs(this.range.from).format('YYYY-MM-DD'),
        to: dayjs(this.range.to).format('YYYY-MM-DD'),
      }

      // ヒートマップ用データの取得処理実行
      axios.get(`/api/analysis/summary-device/${this.tab.current}`, {
        params
      }).then(res => {
        // レスポンスデータの内容がイレギュラーな場合は処理終了
        if (!res.data || !res.data.items) throw new Error('Invalid response data.');

        // パイチャート更新
        this.graphModule.graph(res.data);

        // データリスト更新
        this.graphModule.dataList({
          key: this.sort.key,
          order: this.sort.type,
        });

        // ローダー非表示設定
        setTimeout(() => {
          this.isLoadingGraph = false;
          this.isLoadingDataTable = false;
        }, 300)
      })
        .catch(_e => {
          // エラーモーダル表示
          this.isError = true;
          this.errorMessage = '配信結果データの取得に失敗しました';

          // ローダー非表示設定
          setTimeout(() => {
            this.isLoadingGraph = false;
            this.isLoadingDataTable = false;
          }, 300)
        });
    },

    onTabClick: function(selected) {
      // 選択値が設定されていない場合は処理終了
      if (!selected) return;

      // 選択値が現在の選択値値と同じ場合は処理終了
      if (selected == this.tab.current) return

      // 選択値を現在のタブ名に設定
      this.tab.current = selected;

      // データ更新
      this.updateDataset();
    },

    onSortClick: function(e, key) {
      // ローダー表示設定
      this.isLoadingDataTable = true;

      // クリックしたソートボタンの状態で昇順・皇潤を判定 && ソートボタンの表示を切り替え
      if (e.target.classList.contains('c-btn--sort-desc')) {
        this.sort.key = key;
        this.sort.type = 'asc';
        e.target.classList.remove('c-btn--sort-asc');
        e.target.classList.remove('c-btn--sort-desc');
        e.target.classList.add('c-btn--sort-asc');
      } else {
        this.sort.key = key;
        this.sort.type = 'desc';
        e.target.classList.remove('c-btn--sort-asc');
        e.target.classList.remove('c-btn--sort-desc');
        e.target.classList.add('c-btn--sort-desc');
      }

      this.graphModule.dataList({
        key: this.sort.key,
        order: this.sort.type,
      });

      // ローダー非表示設定
      setTimeout(() => {
        this.isLoadingDataTable = false;
      }, 300)
    },

    onDateRangeChanged: function(range){
      // 取得データ期間の更新
      this.range.from = range.start;
      this.range.to= range.end;

      // データ更新
      this.updateDataset();
    },

    // -----------------------------------------------------------------------------------------------------
    // エミット系メソッド一覧: 子孫のUI操作にフックエミットコールされるか、引き渡した関数オブジェクトからコールされるメソッド
    // -----------------------------------------------------------------------------------------------------
    // クリック: エラーモーダルを閉じる処理
    onCloseErrorModal: function() {
      this.isError = false
      this.errorMessage = ''
    },
  }
}
</script>
